import { all } from "redux-saga/effects";
import * as clientSaga from "./client";

import { commonSaga } from "./common";
import { uploadSaga } from "./upload";
import { guestSaga } from "./guest";
import { userSaga } from "./user";

export default function* rootSaga() {
  yield all([
    /*** client Sagas (start) */
    clientSaga.dashboardSaga(),
    clientSaga.sensorSaga(),
    clientSaga.sensorLiveDataSaga(),
    clientSaga.sensorTotalDataSaga(),
    clientSaga.sensorTotalConsumptionSaga(),
    clientSaga.sensorGraphSaga(),
    clientSaga.reportsSaga(),
    clientSaga.alertsSaga(),
    clientSaga.cycleReportSaga(),
    /*** client Sagas (end) */

    commonSaga(),
    uploadSaga(),
    guestSaga(),
    userSaga()
  ]);
}
